import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddStaffComponent } from '../add-staff/add-staff.component';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { AddSubfranchiseComponent } from '../add-subfranchise/add-subfranchise.component';

@Component({
  selector: 'app-my-subfranchise',
  templateUrl: './my-subfranchise.component.html',
  styleUrls: ['./my-subfranchise.component.css']
})
export class MySubfranchiseComponent implements OnInit {
  type:any;
 allStaffRecords:any;
  constructor(private modalService: NgbModal,
    private rsbService:RsbService,
    private lookupModel:RsbLookupModel
  ) { }

  ngOnInit(): void {
    this.getStaff();
  }
  getStaff(): void{
    this.rsbService.getStaffDataWithoutPagination(this.type?this.type:'subfranchise').subscribe((rsp)=>{
      if(rsp.statusCode === 0){
        this.allStaffRecords=rsp.contents
      }
    })
  }
  addStaff(): void{
    const modalRef = this.modalService.open(AddSubfranchiseComponent);

    modalRef.result.then((result) => {
      const rslt=result;
      this.type=rslt.type;
      const arg={
        name:rslt.name,
        email:rslt.email,
        mobile:rslt.mobile,
        city:rslt.city,
        district:rslt.district,
        type:rslt.type,
        franchiseId:this.lookupModel.getLoggedUser().franchiseId
      }
      this.rsbService.addMyStaff(arg).subscribe((rsp)=>{
        if(rsp && rsp.statusCode===0){
          this.getStaff();
          
        }
      })
    }, (reason) => {
      console.log('Modal dismissed:', reason);
    });
  }
 
}


